export default "/_next/static/images/after-722dd6665bb9b57176e1c0ca1b1a655d.png";